import React, { ReactElement } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import {selectTrendsCellMenuTop, selectTrendsCellMenuLeft, setNewGraph, selectNewGraph, selectKenngrossen, selectMessstellen} from "./trendsCellMenuSlice"
import { getTrendsGraphLine,  selectTrendsGraphTabs,  setSelectedCell } from './trendsSlice';
import {
  selectMessstelleWertTemp,  
} from "../../../features/filter/messstellenFilterSlice";
import {
  selectKenngroesseWertTemp,
} from "../../../features/filter/kenngroesseSlice";
import { graphTab } from './trendsTypes';
import { selectselectedCalculatedTrend } from "./trendsFilterSlice";


function TrendsCellMenu(): ReactElement {

  
  const dispatch = useAppDispatch();
  
  const top = useAppSelector(selectTrendsCellMenuTop);
  const left = useAppSelector(selectTrendsCellMenuLeft);
  const newGraph = useAppSelector(selectNewGraph);
  const messtellenClick = useAppSelector(selectMessstellen);
  const kenngroessenClick = useAppSelector(selectKenngrossen);

  const kenngroesseFilterWert = useAppSelector(selectKenngroesseWertTemp);
  const messstelleFilterWert = useAppSelector(selectMessstelleWertTemp);

  const selectedCalculatedTrend = useAppSelector(selectselectedCalculatedTrend);
  
  const graphTabList = useAppSelector(selectTrendsGraphTabs);


  function createMenuItem(tab: graphTab) {
    const name = tab.name;

    const getGroupedBy = (groupingCriteria: string): string => {
      const groupedBy = groupingCriteria;
      return groupedBy;
    }   

    return (
      <ListItem button alignItems='center' onClick={() => {
        dispatch(getTrendsGraphLine(selectedCalculatedTrend?.id, messstelleFilterWert.find(x => x.name == messtellenClick)!, kenngroessenClick, `${getGroupedBy(tab.groupedBy)}`, tab.name)); 
        dispatch(setSelectedCell(false)); 
        dispatch(setNewGraph(false));
       
       
      }}>
            <ListItemText primary= {`${name}`  } />
          </ListItem>
    )
  }

  return (
  <div onMouseEnter={() => dispatch(setSelectedCell(true))}  style={{display: "flex", position:"absolute",
  top: `${top - 60}px`, left: `${left}px`
   }}>
    <List style={{ backgroundColor:"#fff", minHeight: "11.5em", maxHeight: "20em", height: "auto", borderRadius: "4px", boxShadow: " 3px 3px 3px 2px rgba(100, 100, 100, 0.175)" }} >
      <ListItem button onMouseOver={() => {dispatch(setNewGraph(true))}} onClick={() => {dispatch(setNewGraph(!newGraph))}} >
          <ListItemIcon>
            < AddIcon style={{width: "24px"}}/>
          </ListItemIcon>
          <ListItemText primary="Neuer Tab" />
          <ListItemIcon>
            < ArrowRightIcon style={{marginLeft: "24px"}}/>
          </ListItemIcon>
      </ListItem>
      <Divider orientation='horizontal'></Divider>

      {graphTabList.map(el => el.isOld ? "" : createMenuItem(el))}
    </List>

      { newGraph ? 
      <List onMouseLeave={() => {dispatch(setNewGraph(false))}} style={{border: "1px solid #f0f0f0", backgroundColor:"#ffffff", borderRadius: "4px", boxShadow: " 3px 3px 3px 2px rgba(150, 150, 150, 0.2)", height: "11.5em", width: "11.5em", marginLeft: "-2em", overflow: "visible" }}><ListItem onMouseOver={() => {dispatch(setNewGraph(true)) }}>Gruppiert nach</ListItem><Divider onMouseOver={() => {dispatch(setNewGraph(true))}} orientation='horizontal'></Divider><ListItem onMouseOver={() => {dispatch(setNewGraph(true))}} button alignItems='center' 
      onClick={() => {dispatch(getTrendsGraphLine(selectedCalculatedTrend?.id, messstelleFilterWert.find(x => x.name == messtellenClick)!, kenngroessenClick, "messstelle", undefined)); dispatch(setSelectedCell(false)); dispatch(setNewGraph(false))}} >
          <ListItemText primary="Messstellen" />
      </ListItem><ListItem onMouseOver={() => {dispatch(setNewGraph(true))}} button alignItems='center' onClick={() => {dispatch(getTrendsGraphLine(selectedCalculatedTrend?.id, messstelleFilterWert.find(x => x.name == messtellenClick)!, kenngroessenClick, "kenngroesse", undefined)); dispatch(setSelectedCell(false)); dispatch(setNewGraph(false))}}>
          <ListItemText primary="Kenngroesse" />
      </ListItem>
      </List>
          : ""}

</div>
)
}

export default TrendsCellMenu;